module.exports = "./img/07b7c0f774c4ef556de3f4a85164eb70.jpg";